import { createTheme } from "@mui/material/styles";

// Elite Mind brand colours — from colour-swatches.svg
const brand = {
  forestGreen: "#1C3D2E", // Primary / Brand
  warmGold: "#C4922A", // Accent / CTA
  nearBlack: "#1A1A1A", // Body text
  cream: "#F7F5F0", // Background / Surface
  sage: "#E8EDE5", // Secondary surface
} as const;

const theme = createTheme({
  palette: {
    primary: {
      main: brand.forestGreen,
      contrastText: "#FFFFFF",
    },
    secondary: {
      main: brand.warmGold,
      contrastText: "#FFFFFF",
    },
    background: {
      default: brand.cream,
      paper: "#FFFFFF",
    },
    text: {
      primary: brand.nearBlack,
      secondary: "#6B7280",
    },
  },
  typography: {
    fontFamily: "'Source Sans 3', 'Helvetica Neue', Arial, sans-serif",
    h1: { fontFamily: "'Playfair Display', Georgia, serif" },
    h2: { fontFamily: "'Playfair Display', Georgia, serif" },
    h3: { fontFamily: "'Playfair Display', Georgia, serif" },
    h4: { fontFamily: "'Playfair Display', Georgia, serif" },
    h5: { fontFamily: "'Playfair Display', Georgia, serif" },
    h6: { fontFamily: "'Playfair Display', Georgia, serif" },
  },
  shape: {
    borderRadius: 8,
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: "none",
          fontWeight: 600,
        },
      },
    },
    MuiAppBar: {
      styleOverrides: {
        root: {
          backgroundColor: brand.forestGreen,
        },
      },
    },
  },
});

export { brand };
export default theme;
